import { EnvInfo, getEnvParameters } from '../shared/env'
import { Page } from '../../types'

type ClientCSharpApplicationProps = {
    license: string
    needsLicenseFile: boolean
}

const getEnvParamsConstruction = (env: EnvInfo) => {
    const params = env.parameters
    const formatItem = (key: string) => {
        const info = params[key]
        return `env.${key} = ${info.type == 'string' ? '"' + info.placeholder + '"' : info.placeholder };\n`
    }
    const setup = Object.keys(params).map(formatItem).join('')
    return `using var env = new GRBEnv(true);\n${setup}env.Start();\n`
}

const render = ({ license, needsLicenseFile } : ClientCSharpApplicationProps): JSX.Element => {
    const env = getEnvParameters(license)
    const codeUsage = `using var model = new GRBModel(env);\n# Build your model\nmodel.optimize()`
    const codeWith =  `using var env = new GRBEnv();\n${codeUsage}`
    const codeWithout = env != undefined ? getEnvParamsConstruction(env) : null
    
    return <>
        {!needsLicenseFile && <h3>Using the license file</h3>}
        <p>When you have a license file stored as described previously, then constructing your Gurobi model is fairly straightforward.
            Gurobi will load the license file automatically as soon as the <code>env</code> variable is initialized.
        </p>
        <pre>{codeWith}</pre>
        {!needsLicenseFile && <>
            <h3>Without the license file</h3>
            <p>If you prefer configuration through code, you may leave out the license file and configure Gurobi as follows. {env?.hint}</p>
            <pre>{codeWithout}</pre>
            </>
        }
    </>
}

const ClientCSharpApplication : Page<ClientCSharpApplicationProps> = { key: 'client-csharp-application', title: 'Write your application', render }

export default ClientCSharpApplication